"use client";

import { FC, useState } from "react";

import { Button } from "@/components/Button";
import Modal from "@/components/Modal";
import { getDataAutomationId, getDataLinkAttributes } from "@/helpers";
import { Card } from "@/types/General";

type ProductCardProps = Extract<Card, { type: "Product" }>;

export const ProductCard: FC<ProductCardProps> = (props) => {
  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <article
      data-automation-group="card"
      className="flex h-full flex-col py-5 sm:px-5"
    >
      <div className="mb-4 flex flex-col gap-1">
        <h3>
          {props.thirdLink?.url ? (
            <Button
              size="s"
              variant="tertiary"
              className="sm:!text-subhead-xs flex w-fit p-0 !text-lg font-bold"
              href={props.thirdLink.url}
              {...getDataAutomationId("cta-button-tertiary")}
              {...getDataLinkAttributes(props.thirdLink)}
            >
              {props.title}
            </Button>
          ) : (
            <span className="text-headline sm:text-subhead-xs text-lg font-bold">
              {props.title}
            </span>
          )}
        </h3>
        {props.subhead && (
          <div
            className="text-headline text-body-s font-roboto-slab"
            dangerouslySetInnerHTML={{ __html: props.subhead }}
          />
        )}
      </div>

      <div
        className="text-body-secondary text-body-s"
        dangerouslySetInnerHTML={{ __html: props.description }}
      />

      <div className="mt-auto flex flex-row flex-wrap items-start justify-start gap-6 pt-6 sm:justify-center">
        {props.link && (
          <div className="inline-flex w-fit flex-col items-center gap-2">
            <Button
              size="s"
              variant="primary"
              className="flex h-fit w-fit"
              href={props.link.url}
              {...getDataAutomationId("cta-button")}
              {...getDataLinkAttributes(props.link)}
            >
              {props.link.title}
            </Button>
            {props.link.underTitle && (
              <span className="text-body-secondary text-body-xs text-center">
                {props.link.underTitle}
              </span>
            )}
          </div>
        )}
        {props.secondLink && (
          <>
            <Button
              size="s"
              variant="secondary"
              className="flex h-fit w-fit"
              {...getDataAutomationId("cta-button-secondary")}
              {...getDataLinkAttributes(props.secondLink)}
              onClick={() => setIsModalOpened(true)}
            >
              {props.secondLink.title}
            </Button>
            <Modal
              open={isModalOpened}
              onClose={() => setIsModalOpened(false)}
              variant="minimal"
            >
              {props.modal}
            </Modal>
          </>
        )}
      </div>
    </article>
  );
};
